 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML000_COVER from '@/components/xhtml/000_Cover'
 import XHTML002_DEDICATION from '@/components/xhtml/002_Dedication'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTML004_COPYRIGHT from '@/components/xhtml/004_Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML006_PREFACE from '@/components/xhtml/006_Preface'
 import XHTML007_ACKNOWLEDGEMENTS from '@/components/xhtml/007_Acknowledgements'
 import XHTML009_INTRODUCTION from '@/components/xhtml/009_Introduction'
 import XHTML010_CHAPTER_1 from '@/components/xhtml/010_Chapter_1'
 import XHTML011_CHAPTER_2 from '@/components/xhtml/011_Chapter_2'
 import XHTML012_CHAPTER_3 from '@/components/xhtml/012_Chapter_3'
 import XHTML013_CHAPTER_4 from '@/components/xhtml/013_Chapter_4'
 import XHTML014_CHAPTER_5 from '@/components/xhtml/014_Chapter_5'
 import XHTML015_CHAPTER_6 from '@/components/xhtml/015_Chapter_6'
 import XHTML016_CHAPTER_7 from '@/components/xhtml/016_Chapter_7'
 import XHTML017_CHAPTER_8 from '@/components/xhtml/017_Chapter_8'
 import XHTML018_CHAPTER_9 from '@/components/xhtml/018_Chapter_9'
 import XHTML019_CHAPTER_10 from '@/components/xhtml/019_Chapter_10'
 import XHTML020_CHAPTER_11 from '@/components/xhtml/020_Chapter_11'
 import XHTML021_CHAPTER_12 from '@/components/xhtml/021_Chapter_12'
 import XHTML022_CHAPTER_13 from '@/components/xhtml/022_Chapter_13'
 import XHTML023_CHAPTER_14 from '@/components/xhtml/023_Chapter_14'
 import XHTML024_BM1 from '@/components/xhtml/024_BM1'
 import XHTML025_ENDNOTES from '@/components/xhtml/025_Endnotes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/006_Preface",
 			"name" : "xhtml/006_Preface",
 			"component" : XHTML006_PREFACE
 		},
 		{
 			"path" : "/xhtml/007_Acknowledgements",
 			"name" : "xhtml/007_Acknowledgements",
 			"component" : XHTML007_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/009_Introduction",
 			"name" : "xhtml/009_Introduction",
 			"component" : XHTML009_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/010_Chapter_1",
 			"name" : "xhtml/010_Chapter_1",
 			"component" : XHTML010_CHAPTER_1
 		},
 		{
 			"path" : "/xhtml/011_Chapter_2",
 			"name" : "xhtml/011_Chapter_2",
 			"component" : XHTML011_CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js